"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdContrattiService = void 0;
const request_1 = require("../common/request");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const network_config_1 = require("../common/network.config");
const constants_1 = require("../common/constants");
const bff_interfaces_1 = require("../interfaces/bff.interfaces");
class TpdContrattiService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
        this.headers = {
            "x-unipol-canale": "AR",
        };
        this.preventivi = {
            getOfferte: (numQuote, numPrev, num) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const salvaOfferte = yield nodejs_library_1.Helpers.SessionHelper.getData("salvaofferte");
                    if (network_config_1.CONFIG.LOCALHOSTURLS || salvaOfferte == "true") {
                        // || location.href.indexOf("inte.") > -1
                        console.log("*** [getOfferte] *** trying to get getOfferte from localstorage");
                        try {
                            const getOfferte = yield nodejs_library_1.Helpers.SessionHelper.getData("getOfferte");
                            if (!getOfferte) {
                                throw new Error("");
                            }
                            const response = JSON.parse(getOfferte);
                            console.log("*** [getOfferte] *** returned getOfferte from localStorage");
                            return Promise.resolve(response);
                        }
                        catch ($) {
                            console.log("*** [getOfferte] *** returned getOfferte from service");
                            return this.preventivi.getOfferteFromService().then((response) => {
                                void nodejs_library_1.Helpers.SessionHelper.setData("getOfferte", JSON.stringify(response));
                                return response;
                            });
                        }
                    }
                    return this.preventivi.getOfferteFromService(numQuote, numPrev, num);
                }
                catch (e) {
                    return Promise.reject(e);
                }
            }),
            getOfferteFromService: (numQuote, numPrev, num) => {
                const request = new request_1.Request("contratti/v2/offerte", {
                    queryParams: { numQuote, numPrev, num },
                    headers: this.headers,
                });
                return this.commonNetworkService.get(request.completeUrl, request.headers).then((resp) => {
                    var _a;
                    return ({
                        pratiche: ((_a = resp === null || resp === void 0 ? void 0 : resp["bdy"]) === null || _a === void 0 ? void 0 : _a.pratiche)
                            ? resp["bdy"].pratiche
                            : resp["pratiche"],
                    });
                });
            },
            getDettaglioPreventivo: (idPreventivo) => {
                const headers = { "x-unipol-canale": "AR" };
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}`, {
                    headers,
                });
                return this.commonNetworkService.get(request.completeUrl, request.headers);
            },
            verificaPremioPreventivo: (idPreventivo, versione, targa, dataDecorrenza) => {
                const body = {
                    targa,
                    dataDecorrenza,
                };
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}/${versione}/verifica`, { body, headers: this.headers });
                return this.commonNetworkService.post(request.completeUrl, request.body, request.headers).then((response) => {
                    response["unibox"] =
                        response["unibox"] ===
                            constants_1.Constants.acquistoPreventiviTipoUniboxMap.ASSENTE ||
                            response["unibox"] === ""
                            ? null
                            : response["unibox"];
                    return response;
                });
            },
            associaDocumenti: (idPreventivo, versione, idDocumento, file, mime, filename) => {
                const formData = new FormData();
                formData.append("file", file, filename);
                formData.append("mime", mime);
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}/${versione}/documenti/${idDocumento}`, { headers: this.headers }, undefined, undefined, "url_pub");
                // TODO: controllare che funzioni davvero
                // return this.baseCommunicator.formDataPost(request, formData);
                return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
            },
            modificaConsensi: (idPreventivo, versione, targa, consensi) => {
                const body = {
                    targa,
                    consensi,
                };
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}/${versione}/consensi`, { body, headers: this.headers });
                return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
            },
            getUnibox: (idPreventivo, versione) => {
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}/${versione}/unibox`, { headers: this.headers });
                return this.commonNetworkService.get(request.completeUrl, request.headers);
            },
            setUnibox: (preventivo, uniboxPageInfo) => {
                var _a, _b, _c;
                const idPreventivo = preventivo.idPrevQuo;
                const versione = preventivo.versionePrev;
                // TODO: trasformare in FormArray
                const cellulariAlternativi = [
                    uniboxPageInfo.uniboxInfo.cellulareAlternativo1,
                    uniboxPageInfo.uniboxInfo.cellulareAlternativo2,
                    uniboxPageInfo.uniboxInfo.cellulareAlternativo3,
                ]
                    .filter(Boolean)
                    .map((numero) => ({
                    contattoTelefonico: numero,
                }));
                const deliveryAddress = uniboxPageInfo.deliveryAddress || {
                    via: null,
                    numero: null,
                    esponente: null,
                    provincia: null,
                    stato: null,
                    comune: null,
                    cap: null,
                };
                const stato = deliveryAddress.stato ? deliveryAddress.stato : "";
                let codiceStato = "";
                for (const u of constants_1.Constants.acquistoPreventiviStatiMap) {
                    if (u.nome === stato) {
                        codiceStato = u.code;
                        break;
                    }
                    else if (u.code === stato) {
                        codiceStato = u.code;
                        break;
                    }
                }
                const addressHeader = uniboxPageInfo.addressHeader || {};
                const indirizzoFixed = `${deliveryAddress.via ? deliveryAddress.via : ""} ${deliveryAddress.numero ? deliveryAddress.numero : ""}${deliveryAddress.esponente ? ` ${deliveryAddress.esponente}` : ""}`;
                const indirizzoSpedizione = {
                    nomeCognome: addressHeader.nomeCompleto
                        ? addressHeader.nomeCompleto
                        : null,
                    presso: addressHeader.presso ? addressHeader.presso : null,
                    cellulare: addressHeader.cellulareSpedizione
                        ? addressHeader.cellulareSpedizione
                        : null,
                    indirizzo: indirizzoFixed,
                    stato: codiceStato ? codiceStato : null,
                    provincia: deliveryAddress.provincia,
                    comune: deliveryAddress.comune,
                    cap: deliveryAddress.cap,
                    consegnaDomicilio: /^Ritiro in agenzia$/i.test((_a = uniboxPageInfo.deliveryAddress) === null || _a === void 0 ? void 0 : _a.tipo)
                        ? bff_interfaces_1.ConsegnaDomicilioEnum.AGENZIA
                        : /^Residenza$/i.test((_b = uniboxPageInfo.deliveryAddress) === null || _b === void 0 ? void 0 : _b.tipo)
                            ? bff_interfaces_1.ConsegnaDomicilioEnum.RESIDENZA
                            : bff_interfaces_1.ConsegnaDomicilioEnum.ALTRO,
                };
                const body = {
                    targa: preventivo.targaTelaio.replace(/\s/g, ""),
                    unibox: {
                        tipo: preventivo.unibox && preventivo.unibox.tipo
                            ? preventivo.unibox.tipo
                            : preventivo.unibox,
                        chilometriDichiarati: uniboxPageInfo.uniboxInfo.kmPercorsi
                            ? uniboxPageInfo.uniboxInfo.kmPercorsi.toString()
                            : null,
                        coloreVeicolo: uniboxPageInfo.uniboxInfo.coloreVeicolo,
                        flagContraente: ((_c = uniboxPageInfo.uniboxInfo.contattareContraente) === null || _c === void 0 ? void 0 : _c.toString()) ===
                            "true",
                        contattoPerSinistro: uniboxPageInfo.uniboxInfo.personaDaContattare
                            ? uniboxPageInfo.uniboxInfo.personaDaContattare
                            : preventivo.contattoPerSinistro,
                        cellulare: uniboxPageInfo.uniboxInfo.cellulareContraente,
                        recapitiTelefonici: cellulariAlternativi,
                        flagDichiarazioneContrattualeAlfa: true,
                        indirizzoSpedizione,
                        codiceInstallatore: uniboxPageInfo.uniboxInfo.codiceInstallatore
                            ? "" + uniboxPageInfo.uniboxInfo.codiceInstallatore
                            : null,
                        livelloPrivacy: uniboxPageInfo.uniboxInfo.livelloPrivacy,
                    },
                };
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}/${versione}/unibox`, {
                    body,
                    headers: this.headers,
                });
                return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
            },
            richiediSpedizione: (idPreventivo, versione, indirizzoDiSpedizione) => {
                const body = indirizzoDiSpedizione;
                const request = new request_1.Request(`contratti/v1/preventivi/${idPreventivo}/${versione}/richiediSpedizione`, { headers: this.headers, body });
                return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
            },
        };
    }
}
exports.TpdContrattiService = TpdContrattiService;
